import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Appointments from "@/pages/Appointments";
import Consultation from "@/pages/Consultation";
import Consultations from "@/pages/Consultations";
import Investigations from "@/pages/Investigations";
import Admissions from "@/pages/Admissions";
import AdmissionDetail from "@/pages/AdmissionDetail";
import Certificates from "@/pages/Certificates";
import Prescriptions from "@/pages/Prescriptions";
import Billing from "@/pages/Billing";
import Reports from "@/pages/Reports";
import AuditLogs from "@/pages/AuditLogs";
import RecycleBin from "@/pages/RecycleBin";
import Settings from "@/pages/Settings";
import "@/App.css";

function Gate() {
  const { user } = useApp();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <p className="text-sm font-mono text-muted-foreground animate-pulse">INITIALISING MEDICORE…</p>
      </div>
    );
  }
  if (user === false) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Shell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/patients" element={<Patients />} />
        <Route path="/patients/:id" element={<PatientDetail />} />
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/consultations" element={<Consultations />} />
        <Route path="/consultation/:id" element={<Consultation />} />
        <Route path="/investigations" element={<Investigations />} />
        <Route path="/admissions" element={<Admissions />} />
        <Route path="/admissions/:id" element={<AdmissionDetail />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/prescriptions" element={<Prescriptions />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/audit" element={<AuditLogs />} />
        <Route path="/recycle-bin" element={<RecycleBin />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Gate />
        <Toaster position="top-right" richColors />
      </AppProvider>
    </BrowserRouter>
  );
}
